module.exports = __webpack_public_path__ + "img/flag-PE.f70824ac.svg";